import { getInitialStateFromConfig } from "helpers/form";
import { minTime } from "helpers/validators";

const config = {
    averageSpeed: {
        // field
        label: "Средняя скорость машин (км/ч)",
        inputProps: { name: "averageSpeed", type: "number", step: "1", placeholder: 80, min: 0 },
    },
    workHours: {
        // field
        label: "Кол-во часов для поездки в сутки",
        inputProps: { name: "workHours", type: "number", step: "1", placeholder: 8, min: 0, max: 24 },
    },
    maxLoadUnloadPeriod: {
        // field
        label: "Время загрузки/выгрузки (ч)",
        inputProps: { name: "maxLoadUnloadPeriod", type: "number", step: "1", placeholder: 4, min: 4, max: 24 },
    },
    emptyMileagePointStayPeriod: {
        // field
        label: "Время нахождения в точках в порожних заявках (чч:мм)",
        inputProps: { name: "emptyMileagePointStayPeriod" },
        type: "timespan",
        validators: [minTime("00:15")],
    },
    maxPlannedBidsCount: {
        // field
        label: "Макс. кол-во запланированных заявок",
        inputProps: { name: "maxPlannedBidsCount", type: "number", step: "1", placeholder: 1, min: 0, max: 30 },
    },
    dayStart: {
        // field
        label: "Начало дня",
        inputProps: { name: "dayStart", type: "time", skip: 600, placeholder: "08:00" },
    },
    recommendedBreakTime: {
        // field
        label: "Рекомендуемое время перерыва",
        inputProps: { name: "recommendedBreakTime" },
        type: "timespan",
    },
    recommendedRestTime: {
        // field
        label: "Рекомендуемое время отдыха",
        inputProps: { name: "recommendedRestTime" },
        type: "timespan",
    },
    recommendedWorkTime: {
        // field
        label: "Рекомендуемое время работы",
        inputProps: { name: "recommendedWorkTime" },
        type: "timespan",
    },
    matchingDistributionBidsRadius: {
        // field
        label: "Радиус подбора заказов (км)",
        inputProps: { name: "matchingDistributionBidsRadius", type: "number", placeholder: 40, min: 0 },
    },
    doNotSendDriverNotificationsOffHours: {
        // field
        label: "Не отправлять уведомления водителям в нерабочее время",
        type: "checkbox",
        inputProps: { name: "doNotSendDriverNotificationsOffHours" },
    },
    useLastCarLocationForEmptyMileageBid: {
        // field
        label: "Использовать текущее местоположение машины при создании порожних заявок",
        type: "checkbox",
        inputProps: { name: "useLastCarLocationForEmptyMileageBid" },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
